import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State } from '../reducers/chart.reducer';
import { chartFeatureKey } from '../reducers/chart.reducer';

export const selectChartFeature = createFeatureSelector<State>(chartFeatureKey);

export const selectColors = createSelector(selectChartFeature, (state) => state.colors);
